import { render, staticRenderFns } from "./list.vue?vue&type=template&id=7faaf51d&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=7faaf51d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7faaf51d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7faaf51d')) {
      api.createRecord('7faaf51d', component.options)
    } else {
      api.reload('7faaf51d', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=7faaf51d&scoped=true&", function () {
      api.rerender('7faaf51d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hotel/list.vue"
export default component.exports